// @flow

export const LIST_SCREENING_PARAMS: 'list/screening_params' = 'list/screening_params';
import ScreeningParams from 'models/ScreeningParams';

export type Action = | {
  type: typeof LIST_SCREENING_PARAMS,
  listScreeningParams: Array<ScreeningParams>
};